// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__GSZBZ","title":"styles_title__nRTRu","table":"styles_table__k2tM1"};